<template>
  <div v-if="visible" class="test-phone-numbers small mt-1">
    <span class="text-muted">Test environment — use only these numbers, nobody can receive an SMS on them:</span>
    <code v-for="number in numbers" :key="number" class="test-phone-numbers__number">{{ number }}</code>
  </div>
</template>

<script>
// Numbers ACMA reserved for film/TV (0491 570 xxx): they are valid mobiles for our validation but
// are never assigned to a real subscriber. Shown only outside production so a tester never types a real number.
export const TEST_PHONE_NUMBERS = ['+61 491 570 006', '+61 491 570 156', '+61 491 570 157']

export default {
  name: 'TestPhoneNumbers',
  data() {
    return { numbers: TEST_PHONE_NUMBERS }
  },
  computed: {
    visible() {
      return process.env.NODE_ENV !== 'production'
    }
  }
}
</script>

<style scoped>
.test-phone-numbers__number {
  display: inline-block;
  margin-left: 0.5rem;
  /* one click selects the whole number, ready to copy */
  user-select: all;
  cursor: copy;
}
</style>



// WEBPACK FOOTER //
// src/components/TestPhoneNumbers.vue